import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

interface CommonTooltipProps {
  text: string;
  placement?: 'top' | 'bottom' | 'left' | 'right';
  children: React.ReactElement<any, string | React.JSXElementConstructor<any>>;
}

const ESTooltip: React.FC<CommonTooltipProps> = ({ text, placement = 'top', children }) => (
  <OverlayTrigger
    placement={placement}
    overlay={<Tooltip id="common-tooltip">{text}</Tooltip>}
  >
    {children}
  </OverlayTrigger>
);

export default ESTooltip;
